import { EventEmitter } from 'eventemitter3';
/*
 * Emits an addEventListener/removeEventListener event to a separate EventEmitter
 * whenever a listener is added or removed
 */
export class ObservableEventEmitter {
    delegate = new EventEmitter();
    observer = new EventEmitter();
    on(eventName, listener) {
        this.delegate.on(eventName, listener);
        this.observer.emit('addEventListener', eventName);
    }
    once(eventName, listener) {
        const wrappedFn = (payload) => {
            listener(payload);
            this.observer.emit('removeEventListener', eventName);
        };
        this.delegate.once(eventName, wrappedFn);
        this.observer.emit('addEventListener', eventName);
    }
    off(eventName, listener) {
        this.delegate.off(eventName, listener);
        this.observer.emit('removeEventListener', eventName);
    }
    removeAllListeners() {
        const eventNames = this.delegate.eventNames();
        this.delegate.removeAllListeners();
        for (const eventName of eventNames) {
            this.observer.emit('removeEventListener', eventName);
        }
    }
    emit(eventName, payload) {
        this.delegate.emit(eventName, payload);
    }
    getListenerCount(eventName) {
        return this.delegate.listenerCount(eventName);
    }
    getObserver() {
        return this.observer;
    }
}
//# sourceMappingURL=ObservableEventEmitter.js.map